import { render, staticRenderFns } from "./DriverExpenses.vue?vue&type=template&id=3b8a6961&"
import script from "./DriverExpenses.vue?vue&type=script&lang=ts&"
export * from "./DriverExpenses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VDivider,VList})
